// src/components/Global/DeliveryDateEditor.js
import React, { useState, useEffect, useRef } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { format, parseISO } from 'date-fns';
import { updateOrder, patchOrders, logError } from '../../api';
import { isPropietarioOrAdminOrGestion, isComercial, isJefeComerciales } from '../../services/AuthService';

const DeliveryDateEditor = ({ order, onDateChange, multiSelect = false, selectedOrderIds = [] }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [newDate, setNewDate] = useState(order.deliveryDate ? new Date(order.deliveryDate) : null);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (multiSelect) return;
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setIsEditing(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [multiSelect]);

  const canEdit = (isPropietarioOrAdminOrGestion() || isComercial() || isJefeComerciales()) && !order.isFinalStatus;

  const handleDateChange = async (date) => {
    setNewDate(date);
    const formattedDate = format(date, 'yyyy-MM-dd');

    try {
      setLoading(true);
      if (multiSelect && selectedOrderIds?.length > 0) {
        await patchOrders(selectedOrderIds, { deliveryDate: formattedDate });
        if (onDateChange) onDateChange(selectedOrderIds, formattedDate);
      } else {
        if (formattedDate !== order.deliveryDate) {
          await updateOrder(order.id, { id: order.id, deliveryDate: formattedDate });
          if (onDateChange) onDateChange(order.id, formattedDate);
        }
      }
    } catch (err) {
      logError(err);
      console.error("Error al actualizar la fecha:", err);
    } finally {
      if (!multiSelect) setIsEditing(false);
      setLoading(false);
    }
  };

  return (
    <span style={{ position: 'relative' }}>
      {isEditing && !multiSelect && (
        <div
          ref={inputRef}
          style={{
            position: 'absolute',
            zIndex: 10,
            top: '100%',
            left: 0,
            backgroundColor: 'white',
            boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
            padding: '10px',
            borderRadius: '4px',
          }}
        >
          <DatePicker
            selected={newDate}
            onChange={handleDateChange}
            dateFormat="yyyy-MM-dd"
            disabled={loading}
            autoFocus
            inline
            minDate={new Date()}
          />
        </div>
      )}

      {multiSelect ? (
        <DatePicker
          selected={newDate}
          onChange={handleDateChange}
          dateFormat="yyyy-MM-dd"
          className="form-control"
          placeholderText="Fecha de entrega"
          minDate={new Date()}
        />
      ) : (
        <span
          style={{
            cursor: canEdit ? 'pointer' : 'default',
            color: canEdit ? '#007bff' : 'inherit',
          }}
          onClick={() => canEdit && setIsEditing(true)}
        >
          {newDate ? newDate.toLocaleDateString('es-ES') : 'Sin asignar'}
        </span>
      )}
    </span>
  );
};

export default DeliveryDateEditor;
